import { render, staticRenderFns } from "./ListAddress.vue?vue&type=template&id=19381114"
import script from "./ListAddress.vue?vue&type=script&lang=js"
export * from "./ListAddress.vue?vue&type=script&lang=js"
import style0 from "./ListAddress.vue?vue&type=style&index=0&id=19381114&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports